import { SVGIconComponent } from '../types';

export const traffic: SVGIconComponent = ({ title = '', ...props }) => (
  <svg data-dir="ltr" viewBox="0 0 12 12" {...props}>
    <title>{title}</title>
    <path d="M11.333 4.667h-2v-.76c1.147-.3 2-1.334 2-2.574h-2V.667C9.333.3 9.033 0 8.667 0H3.333c-.366 0-.666.3-.666.667v.666h-2c0 1.24.853 2.274 2 2.574v.76h-2c0 1.24.853 2.273 2 2.573V8h-2c0 1.24.853 2.273 2 2.573v.76c0 .367.3.667.666.667h5.334c.366 0 .666-.3.666-.667v-.76c1.147-.3 2-1.333 2-2.573h-2v-.76c1.147-.3 2-1.333 2-2.573Zm-5.333 6A1.333 1.333 0 1 1 6 8a1.333 1.333 0 0 1 0 2.666Zm0-3.334a1.333 1.333 0 1 1 0-2.666 1.333 1.333 0 0 1 0 2.666ZM6 4a1.333 1.333 0 1 1 0-2.666A1.333 1.333 0 0 1 6 4Z" />
  </svg>
);
